module.exports = __webpack_public_path__ + "static/handshake_5-f42c27ec728d98d5b61d5b035de61949.jpg";